<template>
	<header class="margin-15 margin-left-20">
		<!-- <span
			class="margin-right-20"
		>重量（{{exchangeRateData.weightUnit}}）:{{exchangeRateData.packedWeight}}</span>
		<span>长宽高（{{exchangeRateData.lengthUnit}}):{{exchangeRateData.packedLength}}*{{exchangeRateData.packedWidth}}*{{exchangeRateData.packedHeight}}</span>
		<span v-if="isSplit">ERP SKU {{data.erpSku}}</span>-->
		<span class="margin-right-20">重量(lbs): <span class="font-bold">{{exchangeRateData.packedWeight}}</span></span>
		<span>长宽高(inch): <span class="font-bold">{{exchangeRateData.packedLength}}*{{exchangeRateData.packedWidth}}*{{exchangeRateData.packedHeight}}</span></span>
		<span v-if="isSplit">ERP SKU {{data.erpSku}}</span>
	</header>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	props: {
		data: {
			type:Object,
			default() {
				return {}
			},
		},
		isRate:{
			type:Boolean,
			default:true,
		},
		isSplit: Boolean,
	},
	computed: {
		// ...mapGetters("common", ["getLenUnitList", "getWeightUnitList"]),
		exchangeRateData() {
			if(!this.isRate) return this.data;
			const data = { ...this.data },
				// lengthUnit =  this.getLenUnitList[data.lengthUnit],
				// weightUnit = data.weightUnit = this.getWeightUnitList[data.weightUnit],
				rate = {
					'inch': 2.54,
					'lbs': 453.59237,
					'cm': 1,
					'g': 1
				},
				exchange = function (val = 0, type) {
					return Number(val / (rate[type] || 1)).toFixed(3);
				};
			['packedLength', 'packedWidth', 'packedHeight'].forEach(key => {
				data[key] = exchange(data[key], 'inch');
			});
			['packedWeight'].forEach(key => {
				data[key] = exchange(data[key], 'lbs');
			});
			return data;
		},
	},
}
</script>
